import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { useLocation, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { RootState } from '../reducers';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { TabMenu } from 'primereact/tabmenu';




export const AdminViewPatientlist = () => {
    const location = useLocation();
    const [globalFilter, setGlobalFilter] = useState('');

    const [queryParams, setQueryParams] = useState(null);
    const stepperRef = useRef(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("PatientID") as any);
    }, [location]);
    const { PatientID } = useParams();
    const [activeIndex, setActiveIndex] = useState(0);


    const [Patient, setPatient] = useState<[]>([]);
    const getdata = async () => {
        try {
            const payload = { q: 3, patientid: PatientID };
            const apiname = Admin_API.Pantient_API;
            const data = await LoginService.getData(apiname, payload);
            setPatient(data);
        } catch (error) {

        }
    };
    const [docupload, setDocupload] = useState<[]>([]);

    const getdocs = async () => {
        try {
            const payload = { q: 4, patientid: PatientID };
            const apiname = Admin_API.Pantient_API;
            const data = await LoginService.getData(apiname, payload);
            setDocupload(data);
        } catch (error) {

        }
    };


    useEffectOnce(() => {
        getdata()
        getdocs()

    }, []);
    const [ViewDilog, setViewDilog] = useState(false);

    const [Viewdata, setviewdata] = useState({
        DocID: '',
    });
    const viewduring = (rowData: any) => {
        setviewdata({
            DocID: rowData.DocID,
        });
        setViewDilog(true);
        Docview()

    }
    const [viewdata, setViewdata] = useState<[]>([]);

    const Docview = async () => {
        const { DocID } = Viewdata;
        const payload = { q: 10, docid: DocID };
        const apiname = Admin_API.viewcases_API;
        const data2 = await LoginService.getData(apiname, payload);
        setViewdata(data2)

    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewadminpatientslist.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="content-header">
                            <div className="container-fluid">
                                <div className="grid mb-2">

                                    <div className="col-9">
                                        <h1>Profile</h1>
                                    </div>
                                    <div className="col-3">
                                        <a
                                            title="help"
                                            onClick={(e) => openWindow(e, IUrl)}
                                            style={{

                                                color: "blue",
                                                fontSize: 15, cursor: "pointer"
                                            }}
                                        >Help for this Page &nbsp;
                                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                        </a>
                                    </div>
                                </div>
                            </div>
                        </section >
                        <section className="content">
                            {Patient.map((response: any) =>
                                <>

                                    <div>


                                        {/* <TabMenu> */}

                                        <div className="grid">

                                            <div className="col-3">
                                                <div className="flex flex-column align-items-center font-bold m-2 border-round border-1 border-blue-500 bg-white" style={{ width: "100%", padding: "20px" }}>
                                                    <a key={response.id}>
                                                        <img src={response.photo} style={{ width: '150px', height: '150px', borderRadius: '50%' }} className="profile-user-img img-responsive img-circle" />
                                                    </a>
                                                    <h3 className="profile-username text-center mt-3">{response.firstName}</h3>
                                                    <br></br>
                                                    <h3>patient</h3>


                                                </div>
                                            </div>
                                            <div className="col-9">
                                                <Card className='border-blue-300 surface-overlay border-3 border-round '>
                                                    <div className="col-8">
                                                        <h1>PATIENT(**{response.status}**)</h1>
                                                    </div>
                                                    <Panel header="Personal Details" toggleable  >
                                                        <div className='grid'>
                                                            <div className="col-6">


                                                                <div className="col-2">
                                                                    <label htmlFor="fname" className="block text-900 font-medium "> Name</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="fname" type="text" disabled className="w-full mb-3" value={response.firstName} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label htmlFor="email" className="block text-900 font-medium ">E-mail</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="email" type="text" className="w-full mb-3" disabled value={response.email} />
                                                                </div>
                                                                <div className="col-3">
                                                                    <label htmlFor="email" className="block text-900 font-medium ">Date of  Brith</label>

                                                                </div>
                                                                <div className="col-12">
                                                                    {/* <Dropdown value={.gender}  options={genderoptions} optionLabel="label" optionValue='value' placeholder="Select Gender" className="w-full mb-3" /> */}
                                                                    <InputText id="email" type="text" disabled className="w-full mb-3" value={response.idcard} />

                                                                </div>


                                                                <div className="col-2">
                                                                    <label htmlFor="phone" className="block text-900 font-medium ">Phone</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText
                                                                        type="tel"
                                                                        value={response.phone}
                                                                        disabled
                                                                        placeholder="Enter Phone Number"
                                                                        className="w-full mb-3"
                                                                    />
                                                                </div>

                                                                <div className="col-2">
                                                                    <label htmlFor="cardno" className="block text-900 font-medium ">Door-No</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.dno} />
                                                                </div>
                                                                <div className="col-1">
                                                                    <label htmlFor="cardno" className="block text-900 font-medium ">City </label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.city} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label htmlFor="cardno" className="block text-900 font-medium ">Country </label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.country} />
                                                                </div>
                                                                <div className="col-3">
                                                                    <label htmlFor="cardno" className="block text-900 font-medium ">Reject Reasons</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.reject} />
                                                                </div>
                                                                <div className="col-5">
                                                                    <label htmlFor="cardno" className="block text-900 font-medium ">Emergency Contact Name </label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.contactname} />
                                                                </div>
                                                                <div className="col-5">
                                                                    <label htmlFor="cardno" className="block text-900 font-medium ">Emergency Contact Phone</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="cardno" type="text" disabled className="w-full mb-3" value={response.contactph} />
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="col-3">
                                                                    <label htmlFor="add" className="block text-900 font-medium ">Last Name</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="add" type="text" disabled className="w-full mb-3" value={response.lastName} />
                                                                </div>
                                                                <div className="col-4">
                                                                    <label htmlFor="add" className="block text-900 font-medium">ID Card Number</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="city" type="text" disabled className="w-full mb-3" value={response.idcard} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label htmlFor="state" className="block text-900 font-medium ">Gender</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="state" type="text" disabled className="w-full mb-3" value={response.gender} />
                                                                </div>
                                                                <div className="col-2">
                                                                    <label htmlFor="pincode" className="block text-900 font-medium ">Mobile</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.mob} />
                                                                </div>
                                                                <div className="col-3">
                                                                    <label htmlFor="country" className="block text-900 font-medium ">Fax</label>
                                                                </div>
                                                                <div className="col-12">

                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.fax} />



                                                                </div>

                                                                <div className="col-3">
                                                                    <label htmlFor="country" className="block text-900 font-medium ">Street</label>
                                                                </div>
                                                                <div className="col-12">

                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.street} />



                                                                </div>

                                                                <div className="col-1">
                                                                    <label htmlFor="country" className="block text-900 font-medium ">ZIP</label>
                                                                </div>
                                                                <div className="col-12">

                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.zip} />
                                                                </div>

                                                                <div className="col-1">
                                                                    <label htmlFor="country" className="block text-900 font-medium ">State</label>
                                                                </div>
                                                                <div className="col-12">

                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.state} />
                                                                </div>
                                                                <div className="col-3">
                                                                    <label htmlFor="country" className="block text-900 font-medium ">Skype ID</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.skype} />
                                                                </div>
                                                                <div className="col-4">
                                                                    <label htmlFor="country" className="block text-900 font-medium ">PAYPAL Account</label>
                                                                </div>
                                                                <div className="col-12">
                                                                    <InputText id="pincode" type="text" disabled className="w-full mb-3" value={response.paypal} />
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </Panel>
                                                    <br></br>

                                                </Card>

                                            </div>
                                        </div>

                                    </div>


                                </>
                            )}

                        </section>

                    </div>
                </div>
            </div>
            <section className="content">
                <div className="grid">
                    <div className="col-4"></div>
                    <div className="col-8">
                        <div className="card card-primary">
                            <Card title="">
                                <Panel header="View Documents">

                                    <div className="card card-primary">
                                        <div className="card flex flex-wrap justify-content">
                                            <span className="p-input-icon-left">
                                                <i className="pi pi-search" />
                                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                            </span>
                                        </div>
                                        <DataTable value={docupload} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="doc_name" sortable header="Document Title"></Column>
                                            <Column header="Operation" body={(rowData) => (
                                                <>
                                                    <Button className='mr-1' tooltip="View" severity="info" icon="pi pi-eye" rounded outlined onClick={() => viewduring(rowData)} />
                                                </>
                                            )} />
                                        </DataTable>
                                    </div>
                                </Panel>
                            </Card>
                        </div>

                    </div>
                </div>
            </section>
            <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
                <div className="modal-header">
                </div>
                <div className="modal-body">
                    {viewdata.map((response: any, index: number) =>
                        <div key={index}>
                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                        </div>
                    )}
                </div>
            </Dialog>






        </div>)
}
